import { BANKS, BANKS_OPTIONS } from '../../constants';
import { allowedTenantBankIds } from '../../brand/tenant';
import Checkbox from '../Inputs/Checkbox/Checkbox';
import { useEffect, useMemo, useState } from 'react';
import styles from '../../pages/Deal/deal.module.css';

const BANK_LOGOS = {
  [BANKS.MYCAR]: '/assets/logos/finance-logo.jpg',
};

// allowedBankIds â ÐºÐ°ÐºÐ¸Ðµ Ð±Ð°Ð½ÐºÐ¸ Ð²Ð¾Ð¾Ð±ÑÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ (Ð´Ð»Ñ ÐÐ£-Ð°Ð²ÑÐ¾ ÑÑÐ¾ Ð¿ÑÑÑ
// Ð±Ð°Ð½ÐºÐ¾Ð² Ð¸Ð· USED_CAR_BANK_IDS). ÐÑÑÐ°Ð»ÑÐ½ÑÐµ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¸ Ð½Ðµ Ð¾ÑÐ´Ð°ÑÐ¼ Ð² onChange,
// Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð¾Ð½Ð¸ Ð±ÑÐ»Ð¸ Ð¾ÑÐ¼ÐµÑÐµÐ½Ñ Ð² ÑÐ¾ÑÑÐ°Ð½ÑÐ½Ð½Ð¾Ð¼ ÑÐµÑÐ½Ð¾Ð²Ð¸ÐºÐµ. ÐÐ¾Ð²ÐµÑÑ ÑÑÐ¾Ð³Ð¾ Ð±ÑÐ¾ÐºÐµÑ
// Ð¼Ð¾Ð¶ÐµÑ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ð½Ðµ ÑÐ¾ Ð²ÑÐµÐ¼Ð¸ Ð±Ð°Ð½ÐºÐ°Ð¼Ð¸ (JS Avto â ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ¦Ð, Freedom Ð¸ Ð¨Ð¸Ð½ÑÐ°Ð½).
const BanksPicker = ({ onChange, defaultValue, allowedBankIds }) => {
  const options = useMemo(() => {
    const allowed = allowedTenantBankIds(Array.isArray(allowedBankIds) ? allowedBankIds : null);
    return Array.isArray(allowed) ? BANKS_OPTIONS.filter((bank) => allowed.includes(bank.value)) : BANKS_OPTIONS;
  }, [allowedBankIds]);

  const [data, setData] = useState(() => {
    const selectedBanks = Array.isArray(defaultValue) ? defaultValue.map(String) : null;

    return BANKS_OPTIONS.reduce(
      (acc, bank) => ({
        ...acc,
        [bank.value]: selectedBanks ? selectedBanks.includes(String(bank.value)) : true,
      }),
      {}
    );
  });
  const handleChange = (id, value) => {
    setData({
      ...data,
      [id]: value,
    });
  };

  useEffect(() => {
    const allowed = new Set(options.map((bank) => bank.value));
    onChange(
      Object.keys(data)
        .filter((key) => data[key])
        .map(Number)
        .filter((id) => allowed.has(id))
    );
  }, [data, onChange, options]);

  return (
    <div>
      {options.map((bank) => (
        <label htmlFor={bank.value} className={styles.bank} style={{ padding: '5px 20px', marginBottom: 2, display: 'block', cursor: 'pointer' }}>
          <div className={styles.bank__row} style={{ marginBottom: 0 }}>
            <p className={styles.bank_name}>{bank.label}</p>
            <p>
              <Checkbox id={bank.value} value={data[bank.value]} defaultChecked={data[bank.value]} onChange={handleChange} />
            </p>
          </div>
        </label>
      ))}
    </div>
  );
};

export default BanksPicker;
